import { render, staticRenderFns } from "./yinji-map.vue?vue&type=template&id=405a448e&scoped=true"
import script from "./yinji-map.vue?vue&type=script&lang=js"
export * from "./yinji-map.vue?vue&type=script&lang=js"
import style0 from "./yinji-map.vue?vue&type=style&index=0&id=405a448e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405a448e",
  null
  
)

export default component.exports